/* global CustomEvent, window, netscape, SiteVars, document, HTMLImageElement */
// Blur an image using HTML5 canvas
// Original versions by Mario Klingemann and Michael Dyer

// http://www.quasimondo.com/StackBlurForCanvas/StackBlur.js
// https://github.com/listenrightmeow/stackblur-canvas

function ImageBlur( options ) {
  this.options = {
    radius: 1,
    scale: 1,
    cssCanvas: ("getCSSCanvasContext" in document),
    mulTable: [
      512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512,
      454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512,
      482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456,
      437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512,
      497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328,
      320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456,
      446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335,
      329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512,
      505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405,
      399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328,
      324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271,
      268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456,
      451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388,
      385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335,
      332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292,
      289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259
    ],
    shgTable: [
      9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17,
      17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19,
      19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20,
      20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21,
      21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
      21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22,
      22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
      22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23,
      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
      23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24
    ]
  };

  for ( var key in options ) {
    this.options[ key ] = options[ key ];
  }

  var self = this,
    radius = this.options.radius,
    img = document.createElement( "img" );

  if ( options.path[ 0 ] === "/" ) {
    options.path = SiteVars[ "home_url" ] + options.path;
  } else if ( options.path.indexOf( "cloudfront" ) !== -1 ) {
    var pathStart = options.path.indexOf( "/", 7 );
    options.path = options.path.substr( pathStart );
  }

  img.src = options.path;

  img.onload = function( e ) {

    self.options.width = img.naturalWidth * self.options.scale;
    self.options.height = img.naturalHeight * self.options.scale;

    if ( !self.options.cssCanvas ) {
      self.canvas = document.createElement( "canvas" );

      self.canvas.style.display = "none";
      self.canvas.style.width  = self.options.width + "px";
      self.canvas.style.height = self.options.height + "px";
      self.canvas.width = self.options.width;
      self.canvas.height = self.options.height;

      document.body.insertBefore( self.canvas, document.body.childNodes[ 0 ] );

      self.context = self.canvas.getContext( "2d" );
    } else {
      self.id = Math.random().toString( 36 ).replace( /[^a-z]+/g, "" ).substr( 0, 8 );

      self.context = document.getCSSCanvasContext(
        "2d", self.id, self.options.width, self.options.height
      );
    }

    self.context.clearRect( 0, 0, self.options.width, self.options.height );
    self.context.drawImage( img, 0, 0, self.options.width, self.options.height );

    if ( isNaN( radius ) || radius < 1 ) {
      throw new Error( "Radius required." );
    }

    if ( options.path.match( /\w.\S+png/ ) ) {

      self.stackBlurCanvasRGBA(function() {
        self.apply( "image/jpg" );
      });

    } else {

      self.stackBlurCanvasRGB(function() {
        self.apply( "image/jpg" );
      });

    }

  };

  if ( img.complete ) {
    // $(img).trigger('load')

    var loadEvent = document.createEvent( "HTMLEvents" );
    loadEvent.initEvent( "load", false, false );

    img.dispatchEvent( loadEvent );
  }
}

ImageBlur.prototype = {

  stackBlurCanvasRGBA: function( callback ) {

    var self = this,
      context = this.context,
      radius = this.options.radius,
      topX = 0,
      topY = 0,
      width = this.options.width,
      height = this.options.height,
      imageData;

    if ( isNaN( radius ) || radius < 1 ) {
      return;
    }

    radius |= 0;

    try {
      try {
        imageData = context.getImageData( topX, topY, width, height );
      } catch ( err ) {
        try {
          netscape.security.PrivilegeManager.enablePrivilege( "UniversalBrowserRead" );
          imageData = context.getImageData( topX, topY, width, height );
        } catch ( err ) {
          throw new Error( "unable to access local image data: " + err );
        }
      }
    } catch ( err ) {
      throw new Error( "unable to access image data: " + err );
    }

    var pixels = imageData.data;

    var x, y, i, p, yp, yi, yw, rSum, gSum, bSum, aSum,
      rOutSum, gOutSum, bOutSum, aOutSum,
      rInSum, gInSum, bInSum, aInSum,
      pr, pg, pb, pa, rbs;

    var div = radius + radius + 1,
      w4 = width << 2,
      widthMinus1  = width - 1,
      heightMinus1 = height - 1,
      radiusPlus1  = radius + 1,
      sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2,
      stackStart = self.BlurStack(),
      stack = stackStart,
      stackEnd;

    for ( i = 1; i < div; i++ ) {
      stack = stack.next = self.BlurStack();

      if ( i === radiusPlus1 ) {
        stackEnd = stack;
      }
    }

    stack.next = stackStart;
    var stackIn = null;
    var stackOut = null;

    yw = yi = 0;

    var mulSum = this.options.mulTable[ radius ],
      shgSum = this.options.shgTable[ radius ];

    for ( y = 0; y < height; y++ ) {
      rInSum = gInSum = bInSum = aInSum = rSum = gSum = bSum = aSum = 0;

      rOutSum = radiusPlus1 * (pr = pixels[ yi ]);
      gOutSum = radiusPlus1 * (pg = pixels[ yi + 1 ]);
      bOutSum = radiusPlus1 * (pb = pixels[ yi + 2 ]);
      aOutSum = radiusPlus1 * (pa = pixels[ yi + 3 ]);

      rSum += sumFactor * pr;
      gSum += sumFactor * pg;
      bSum += sumFactor * pb;
      aSum += sumFactor * pa;

      stack = stackStart;

      for ( i = 0; i < radiusPlus1; i++ ) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack.a = pa;
        stack = stack.next;
      }

      for ( i = 1; i < radiusPlus1; i++ ) {
        p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
        rSum += (stack.r = (pr = pixels[ p ])) * (rbs = radiusPlus1 - i);
        gSum += (stack.g = (pg = pixels[ p + 1 ])) * rbs;
        bSum += (stack.b = (pb = pixels[ p + 2 ])) * rbs;
        aSum += (stack.a = (pa = pixels[ p + 3 ])) * rbs;

        rInSum += pr;
        gInSum += pg;
        bInSum += pb;
        aInSum += pa;

        stack = stack.next;
      }

      stackIn = stackStart;
      stackOut = stackEnd;

      for ( x = 0; x < width; x++ ) {
        pixels[ yi + 3 ] = pa = (aSum * mulSum) >> shgSum;
        if ( pa !== 0 ) {
          pa = 255 / pa;
          pixels[ yi ]   = ((rSum * mulSum) >> shgSum) * pa;
          pixels[ yi + 1 ] = ((gSum * mulSum) >> shgSum) * pa;
          pixels[ yi + 2 ] = ((bSum * mulSum) >> shgSum) * pa;
        } else {
          pixels[ yi ] = pixels[ yi + 1 ] = pixels[ yi + 2 ] = 0;
        }

        rSum -= rOutSum;
        gSum -= gOutSum;
        bSum -= bOutSum;
        aSum -= aOutSum;

        rOutSum -= stackIn.r;
        gOutSum -= stackIn.g;
        bOutSum -= stackIn.b;
        aOutSum -= stackIn.a;

        p =  (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

        rInSum += (stackIn.r = pixels[ p ]);
        gInSum += (stackIn.g = pixels[ p + 1 ]);
        bInSum += (stackIn.b = pixels[ p + 2 ]);
        aInSum += (stackIn.a = pixels[ p + 3 ]);

        rSum += rInSum;
        gSum += gInSum;
        bSum += bInSum;
        aSum += aInSum;

        stackIn = stackIn.next;

        rOutSum += (pr = stackOut.r);
        gOutSum += (pg = stackOut.g);
        bOutSum += (pb = stackOut.b);
        aOutSum += (pa = stackOut.a);

        rInSum -= pr;
        gInSum -= pg;
        bInSum -= pb;
        aInSum -= pa;

        stackOut = stackOut.next;

        yi += 4;
      }
      yw += width;
    }


    for ( x = 0; x < width; x++ ) {
      gInSum = bInSum = aInSum = rInSum = gSum = bSum = aSum = rSum = 0;

      yi = x << 2;
      rOutSum = radiusPlus1 * (pr = pixels[ yi ]);
      gOutSum = radiusPlus1 * (pg = pixels[ yi + 1 ]);
      bOutSum = radiusPlus1 * (pb = pixels[ yi + 2 ]);
      aOutSum = radiusPlus1 * (pa = pixels[ yi + 3 ]);

      rSum += sumFactor * pr;
      gSum += sumFactor * pg;
      bSum += sumFactor * pb;
      aSum += sumFactor * pa;

      stack = stackStart;

      for ( i = 0; i < radiusPlus1; i++ ) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack.a = pa;
        stack = stack.next;
      }

      yp = width;

      for ( i = 1; i <= radius; i++ ) {
        yi = (yp + x) << 2;

        rSum += (stack.r = (pr = pixels[ yi ])) * (rbs = radiusPlus1 - i);
        gSum += (stack.g = (pg = pixels[ yi + 1 ])) * rbs;
        bSum += (stack.b = (pb = pixels[ yi + 2 ])) * rbs;
        aSum += (stack.a = (pa = pixels[ yi + 3 ])) * rbs;

        rInSum += pr;
        gInSum += pg;
        bInSum += pb;
        aInSum += pa;

        stack = stack.next;

        if ( i < heightMinus1 ) {
          yp += width;
        }
      }

      yi = x;
      stackIn = stackStart;
      stackOut = stackEnd;
      for ( y = 0; y < height; y++ ) {
        p = yi << 2;
        pixels[ p + 3 ] = pa = (aSum * mulSum) >> shgSum;
        if ( pa > 0 ) {
          pa = 255 / pa;
          pixels[ p ]   = ((rSum * mulSum) >> shgSum) * pa;
          pixels[ p + 1 ] = ((gSum * mulSum) >> shgSum) * pa;
          pixels[ p + 2 ] = ((bSum * mulSum) >> shgSum) * pa;
        } else {
          pixels[ p ] = pixels[ p + 1 ] = pixels[ p + 2 ] = 0;
        }

        rSum -= rOutSum;
        gSum -= gOutSum;
        bSum -= bOutSum;
        aSum -= aOutSum;

        rOutSum -= stackIn.r;
        gOutSum -= stackIn.g;
        bOutSum -= stackIn.b;
        aOutSum -= stackIn.a;

        p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2;

        rSum += (rInSum += (stackIn.r = pixels[ p ]));
        gSum += (gInSum += (stackIn.g = pixels[ p + 1 ]));
        bSum += (bInSum += (stackIn.b = pixels[ p + 2 ]));
        aSum += (aInSum += (stackIn.a = pixels[ p + 3 ]));

        stackIn = stackIn.next;

        rOutSum += (pr = stackOut.r);
        gOutSum += (pg = stackOut.g);
        bOutSum += (pb = stackOut.b);
        aOutSum += (pa = stackOut.a);

        rInSum -= pr;
        gInSum -= pg;
        bInSum -= pb;
        aInSum -= pa;

        stackOut = stackOut.next;

        yi += width;
      }
    }

    context.putImageData( imageData, topX, topY );
    callback();

  },

  stackBlurCanvasRGB: function( callback ) {

    var self = this,
      context = this.context,
      radius = this.options.radius,
      topX = 0,
      topY = 0,
      width = this.options.width,
      height = this.options.height,
      imageData;

    if ( isNaN( radius ) || radius < 1 ) {
      return;
    }

    radius |= 0;

    try {
      try {
        imageData = context.getImageData( topX, topY, width, height );
      } catch ( e ) {
        try {
          netscape.security.PrivilegeManager.enablePrivilege( "UniversalBrowserRead" );
          imageData = context.getImageData( topX, topY, width, height );
        } catch ( e ) {
          throw new Error( "unable to access local image data: " + e );
        }
      }
    } catch ( e ) {
      throw new Error( "unable to access image data: " + e );
    }

    var pixels = imageData.data;

    var x, y, i, p, yp, yi, yw, rSum, gSum, bSum,
    rOutSum, gOutSum, bOutSum,
    rInSum, gInSum, bInSum,
    pr, pg, pb, rbs;

    var div = radius + radius + 1,
      w4 = width << 2,
      widthMinus1  = width - 1,
      heightMinus1 = height - 1,
      radiusPlus1  = radius + 1,
      sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2,
      stackStart = self.BlurStack(),
      stack = stackStart,
      stackEnd;

    for ( i = 1; i < div; i++ ) {
      stack = stack.next = self.BlurStack();
      if ( i === radiusPlus1 ) {
        stackEnd = stack;
      }
    }

    stack.next = stackStart;

    var stackIn = null,
      stackOut = null;

    yw = yi = 0;

    var mulSum = this.options.mulTable[ radius ],
      shgSum = this.options.shgTable[ radius ];

    for ( y = 0; y < height; y++ ) {
      rInSum = gInSum = bInSum = rSum = gSum = bSum = 0;

      rOutSum = radiusPlus1 * (pr = pixels[ yi ]);
      gOutSum = radiusPlus1 * (pg = pixels[ yi + 1 ]);
      bOutSum = radiusPlus1 * (pb = pixels[ yi + 2 ]);

      rSum += sumFactor * pr;
      gSum += sumFactor * pg;
      bSum += sumFactor * pb;

      stack = stackStart;

      for ( i = 0; i < radiusPlus1; i++ ) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack = stack.next;
      }

      for ( i = 1; i < radiusPlus1; i++ ) {
        p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
        rSum += (stack.r = (pr = pixels[ p ])) * (rbs = radiusPlus1 - i);
        gSum += (stack.g = (pg = pixels[ p + 1 ])) * rbs;
        bSum += (stack.b = (pb = pixels[ p + 2 ])) * rbs;

        rInSum += pr;
        gInSum += pg;
        bInSum += pb;

        stack = stack.next;
      }

      stackIn = stackStart;
      stackOut = stackEnd;
      for ( x = 0; x < width; x++ ) {
        pixels[ yi ]   = (rSum * mulSum) >> shgSum;
        pixels[ yi + 1 ] = (gSum * mulSum) >> shgSum;
        pixels[ yi + 2 ] = (bSum * mulSum) >> shgSum;

        rSum -= rOutSum;
        gSum -= gOutSum;
        bSum -= bOutSum;

        rOutSum -= stackIn.r;
        gOutSum -= stackIn.g;
        bOutSum -= stackIn.b;

        p =  (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

        rInSum += (stackIn.r = pixels[ p ]);
        gInSum += (stackIn.g = pixels[ p + 1 ]);
        bInSum += (stackIn.b = pixels[ p + 2 ]);

        rSum += rInSum;
        gSum += gInSum;
        bSum += bInSum;

        stackIn = stackIn.next;

        rOutSum += (pr = stackOut.r);
        gOutSum += (pg = stackOut.g);
        bOutSum += (pb = stackOut.b);

        rInSum -= pr;
        gInSum -= pg;
        bInSum -= pb;

        stackOut = stackOut.next;

        yi += 4;
      }
      yw += width;
    }


    for ( x = 0; x < width; x++ ) {
      gInSum = bInSum = rInSum = gSum = bSum = rSum = 0;

      yi = x << 2;
      rOutSum = radiusPlus1 * (pr = pixels[ yi ]);
      gOutSum = radiusPlus1 * (pg = pixels[ yi + 1 ]);
      bOutSum = radiusPlus1 * (pb = pixels[ yi + 2 ]);

      rSum += sumFactor * pr;
      gSum += sumFactor * pg;
      bSum += sumFactor * pb;

      stack = stackStart;

      for ( i = 0; i < radiusPlus1; i++ ) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack = stack.next;
      }

      yp = width;

      for ( i = 1; i <= radius; i++ ) {
        yi = (yp + x) << 2;

        rSum += (stack.r = (pr = pixels[ yi ])) * (rbs = radiusPlus1 - i);
        gSum += (stack.g = (pg = pixels[ yi + 1 ])) * rbs;
        bSum += (stack.b = (pb = pixels[ yi + 2 ])) * rbs;

        rInSum += pr;
        gInSum += pg;
        bInSum += pb;

        stack = stack.next;

        if ( i < heightMinus1 ) {
          yp += width;
        }
      }

      yi = x;
      stackIn = stackStart;
      stackOut = stackEnd;
      for ( y = 0; y < height; y++ ) {
        p = yi << 2;
        pixels[ p ]   = (rSum * mulSum) >> shgSum;
        pixels[ p + 1 ] = (gSum * mulSum) >> shgSum;
        pixels[ p + 2 ] = (bSum * mulSum) >> shgSum;

        rSum -= rOutSum;
        gSum -= gOutSum;
        bSum -= bOutSum;

        rOutSum -= stackIn.r;
        gOutSum -= stackIn.g;
        bOutSum -= stackIn.b;

        p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2;

        rSum += (rInSum += (stackIn.r = pixels[ p ]));
        gSum += (gInSum += (stackIn.g = pixels[ p + 1 ]));
        bSum += (bInSum += (stackIn.b = pixels[ p + 2 ]));

        stackIn = stackIn.next;

        rOutSum += (pr = stackOut.r);
        gOutSum += (pg = stackOut.g);
        bOutSum += (pb = stackOut.b);

        rInSum -= pr;
        gInSum -= pg;
        bInSum -= pb;

        stackOut = stackOut.next;

        yi += width;
      }
    }

    context.putImageData( imageData, topX, topY );
    callback();

  },

  BlurStack: function() {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      next: null
    };
  },

  apply: function( type ) {
    if ( this.options.cssCanvas ) {
      this.applyCanvasBG();
    } else {
      this.applyDataURL( type );
    }
  },

  applyCanvasBG: function() {
    this.options.el.style.backgroundImage = "-webkit-canvas(" + this.id + ")";
  },

  applyDataURL: function( type ) {
    var base = this.canvas.toDataURL( type ),
      imageBlurredEvent = null;

    this.canvas.parentNode.removeChild( this.canvas );

    if ( this.options.el instanceof HTMLImageElement ) {
      this.options.el.src = base;
    } else {
      this.options.el.style.backgroundImage = "url(" + base + ")";
    }

    if ( typeof window.CustomEvent === "function" ) {
      imageBlurredEvent = new CustomEvent( "image-blurred" );
    } else {
      imageBlurredEvent = document.createEvent( "CustomEvent" );
      imageBlurredEvent.initCustomEvent( "image-blurred", true, true, {});
    }

    this.options.el.dispatchEvent( imageBlurredEvent );
  }

};

module.exports = ImageBlur;
